/**
 * @file Forecast relation component
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { RelationBase } from '../../base/relation/relation.base';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { ForecastService } from '../forecast.service';
import { ForecastFormChildComponent } from '../forecast-form-child/forecast-form-child.component';
import { EventsService } from '../../core/event.service';
import { UserService } from '../../user.service';
import { ActionService } from '../../core/action.service';
var ForecastRelationComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ForecastRelationComponent, _super);
    /**
     * Constructs a forecast relation component.
     * @param configurationsService Service to get the configuration of this component.
     * @param workSlipsService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     * @param route The active route.
     */
    function ForecastRelationComponent(userService, forecastService, dialogService, alertsService, translateService, router, overlayService, localStorageService, route, eventsService, actionService) {
        var _this = _super.call(this, userService, forecastService, dialogService, alertsService, translateService, router, overlayService, localStorageService, route, eventsService, actionService) || this;
        /**
         * The localization domain
         * @memberOf ForecastRelationComponent
         */
        _this.labelDomain = 'FORECAST';
        return _this;
    }
    /**
     * This method is called when save button of the DetailComponent is clicked.
     * @param {Event} event The click event.
     * @memberOf ForecastRelationComponent
     */
    ForecastRelationComponent.prototype.formSave = function (event) {
        // Fix: Invullen Bijzondere dag wordt niet opgeslagen bij knop: diskette #3049
        if (this.dataForm && (this.dataForm.hasChanges || this.dataForm.createMode)) {
            this.dataForm.saveItem(event, true);
            return;
        }
        this.save(event);
    };
    /**
     * This method is called when delete button of the DetailComponent is clicked.
     * @param {Event} event The click event.
     * @memberOf ForecastRelationComponent
     */
    ForecastRelationComponent.prototype.formDelete = function (event) {
        // TODO: De boel opruimen als dit nodig is?
        // Zie ook: Invullen Bijzondere dag wordt niet opgeslagen bij knop: diskette #3049
    };
    /**
     * This method is called when cancel button of the DetailComponent is clicked.
     * @param {Event} event The click event.
     * @memberOf ForecastRelationComponent
     */
    ForecastRelationComponent.prototype.formCancel = function (event) {
        // Fix: Invullen Bijzondere dag wordt niet opgeslagen bij knop: diskette #3049
        this.cancel();
    };
    /**
     * Method to retrieve the requested entities from the backend api.
     * @returns {Observable<QueryResult>} An Observable object that retrieves the requested entities.
     * @memberOf ForecastRelationComponent
     */
    ForecastRelationComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.master == null) {
                    // Soms heb je dynamische parameter waarden nodig van de master.
                    // Daarom stellen we de master nu verplicht
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, _super.prototype.refresh.call(this)];
            });
        });
    };
    return ForecastRelationComponent;
}(RelationBase));
export { ForecastRelationComponent };
